export default __webpack_public_path__ + "static/media/airplane.39b95c27.png";